import React, { useState } from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import Dialog from '@mui/material/Dialog';
import BrandList from './BrandList';
import BrandForm from './BrandForm';

const BrandSettings = () => {
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [brandDialogOpen, setBrandDialogOpen] = useState(false);

  const handleBrandEdit = (brand) => {
    setSelectedBrand(brand);
    setBrandDialogOpen(true);
  };

  const handleBrandSuccess = () => {
    setSelectedBrand(null);
    setBrandDialogOpen(false);
    setRefresh(!refresh);
  };

  const handleAddBrand = () => {
    setSelectedBrand(null);
    setBrandDialogOpen(true);
  };

  return (
    <Container className="settings-page" maxWidth="xl" sx={{ mt: 2, mb: 2, px: 2 }}>
      <Box className="settings-heading" sx={{ mb: 2 }}>
        <Typography 
          variant="h6" 
          sx={{ 
            fontWeight: 600,
            color: 'text.primary',
            mb: 0.5,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            fontSize: '1rem'
          }}
        >
          <LocalFireDepartmentIcon sx={{ fontSize: 24, color: '#f57c00' }} />
          Brand Management
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
          Manage your product brands
        </Typography>
      </Box>

      <Paper className="settings-shell" sx={{ 
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 1
      }}>
        <Box className="settings-content" sx={{ p: 2 }}>
          <BrandList 
            onEdit={handleBrandEdit} 
            onAdd={handleAddBrand}
            key={refresh} 
          />
        </Box>
      </Paper>

      {/* Brand Dialog */}
      <Dialog 
        open={brandDialogOpen} 
        onClose={() => {
          setBrandDialogOpen(false);
          setSelectedBrand(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <BrandForm 
          selected={selectedBrand} 
          onSuccess={handleBrandSuccess} 
          onCancel={() => {
            setBrandDialogOpen(false);
            setSelectedBrand(null);
          }} 
        />
      </Dialog>
    </Container>
  );
};

export default BrandSettings;
